import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import footerStyle from "assets/jss/material-dashboard-pro-react/components/footerStyle";

import {COMPANY_WEB_SITE, COMPANY_BLOG, COMPANY_NAME, SUPPORT_WEB_SITE} from "../../api-config";

function Footer({ ...props }) {
  const { classes, fluid, white } = props;
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white
  });
  var anchor =
    classes.a +
    cx({
      [" " + classes.whiteColor]: white
    });
  var block = cx({
    [classes.block]: true,
    [classes.whiteColor]: white
  });
  return (
    <footer className={classes.footer}>
      <div className={container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href={SUPPORT_WEB_SITE} className={block} target="_blank" rel="noopener noreferrer">
                Support
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href={COMPANY_WEB_SITE} className={block} target="_blank" rel="noopener noreferrer">
                Company
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href={COMPANY_BLOG} className={block} target="_blank" rel="noopener noreferrer">
                Blog
              </a>
            </ListItem>
          </List>
        </div>
        <p className={classes.right}>
          &copy; {1900 + new Date().getYear()}{" "}
          <a href={COMPANY_WEB_SITE} className={anchor} target="_blank" rel="noopener noreferrer">
            {COMPANY_NAME}
          </a>
        </p>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);
